module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (154).90fffcf8.jpg";